import { useEffect } from 'react'
import { PublicClientApplication } from '@azure/msal-browser'
import { msalConfig, loginRequest } from '@config/auth.config'

/**
 * Page de démarrage de l'authentification pour Teams
 * Cette page est ouverte dans une popup par Teams pour l'authentification
 */
const AuthStart = () => {
  useEffect(() => {
    const authenticate = async () => {
      try {
        const msalInstance = new PublicClientApplication(msalConfig)
        await msalInstance.initialize()

        // Rediriger vers Azure AD pour l'authentification
        await msalInstance.loginRedirect({
          ...loginRequest,
          redirectUri: `${window.location.origin}/auth-end`,
        })
      } catch (error) {
        console.error('Authentication start error:', error)
      }
    }

    authenticate()
  }, [])

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100 dark:bg-gray-900">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mx-auto mb-4"></div>
        <p className="text-gray-600 dark:text-gray-300">Redirection vers l'authentification...</p>
      </div>
    </div>
  )
}

export default AuthStart
